import React from "react";
import type { SVGProps } from "react";

const IndexesIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M16 19H20C20.5523 19 21 18.5523 21 18V17C21 15.3431 19.6569 14 18 14H16M13.7639 10C14.3132 10.6137 15.1115 11 16 11C17.6569 11 19 9.65685 19 8C19 6.34315 17.6569 5 16 5C15.1115 5 14.3132 5.38625 13.7639 6M3 18V17C3 15.3431 4.34315 14 6 14H10C11.6569 14 13 15.3431 13 17V18C13 18.5523 12.5523 19 12 19H4C3.44772 19 3 18.5523 3 18ZM11 8C11 9.65685 9.65685 11 8 11C6.34315 11 5 9.65685 5 8C5 6.34315 6.34315 5 8 5C9.65685 5 11 6.34315 11 8Z"
      stroke="#383838"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export default IndexesIcon;

